<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> IJP SG&A Dashboard</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

       <!--Internal SG&A Application -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> Internal SG&A Application
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                            <tr class="bg-i-light">
                               <th rowspan="2">Segment</th>
                               <th rowspan="2">Total Application Received</th>
                               <th colspan="2">Employee Shortlisted</th>
                               <th colspan="3">Employee Not Contacted</th>
                               <th rowspan="2">Employee Rejected</th>
                            </tr>
                            <tr>
                            
                               <th class="bg-info1">No of Shortlisting</th>
                               <th class="bg-purple1">Shortlisting %</th>
                               <th class="bg-success1">Open for 0-3 days</th>
                               <th class="bg-warning1">Open for 4-7 days</th>
                               <th class="bg-danger1">Open for < 8 days</th>
                              
                            </tr>
                         </thead>
                         <tbody>
                            <tr>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                            </tr>
                         </tbody>
                      </table>
                   </div>
                </div>
             </div>

<!--External SG&A Application -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> External SG&A Application
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                            <tr class="bg-i-light">
                            <th rowspan="2">Segment</th>
                            <th rowspan="2">Total Application Received</th>
                            <th colspan="2">Employee Shortlisted</th>
                            <th colspan="3">Employee Not Contacted</th>
                            <th rowspan="2">Employee Rejected</th>
                            </tr>
                            <tr>
                            
                            <th class="bg-info1">No of Shortlisting</th>
                            <th class="bg-purple1">Shortlisting %</th>
                            <th class="bg-success1">Open for 0-3 days</th>
                            <th class="bg-warning1">Open for 4-7 days</th>
                            <th class="bg-danger1">Open for < 8 days</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
            
<!-- Referral SG&A Application -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                <i class="fa fa-link"></i> Referral SG&A Application
                </div>
                <div class="col-12 col-pn">
                <div class="table-responsive">
                    <table class="table table-align">
                        <thead>
                            <tr class="bg-i-light">
                            <th rowspan="2">Segment</th>
                            <th rowspan="2">Total Application Received</th>
                            <th colspan="2">Employee Shortlisted</th>
                            <th colspan="3">Employee Not Contacted</th>
                            <th rowspan="2">Employee Rejected</th>
                            </tr>
                            <tr>
                            
                            <th class="bg-info1">No of Shortlisting</th>
                            <th class="bg-purple1">Shortlisting %</th>
                            <th class="bg-success1">Open for 0-3 days</th>
                            <th class="bg-warning1">Open for 4-7 days</th>
                            <th class="bg-danger1">Open for < 8 days</th>
                            
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            <td>0</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

